export var DEFAULT_ICON_PREFIX = 'wk-icon';
export var FILLED_PREFIX = 'filled';
export var SLUG_CLASS = 'wk-icons-slug';
export var SLUG_SELECTOR = "#" + SLUG_CLASS;
export var DEFAULT_SIZE = 16;
